// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2gKIi","subheader":"ReorderModal_subheader__UI4EB","listWrap":"ReorderModal_listWrap__2hcXM"};